import axios from "axios";

const baseApiUrl = process.env.REACT_APP_BASEURL;
console.log({ baseApiUrl });
export async function fetchData(
  method,
  path,
  reqBody,
  params,
  headers,
  baseUrl
) {
  try {
    const response = await axios({
      method: method?.toLocaleUpperCase() ?? "GET",
      url: (baseUrl ?? baseApiUrl) + path,
      data: reqBody,
      params: params,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", path, error);

    throw error;
  }
}
